import { configureStore } from "@reduxjs/toolkit";
import supportrequestReducer from "./supportrequestSlice";
import baseurlReducer from "./baseurlSlice";
import draftReducer from "./draftSlice";
import modalReducer from "./modalSlice";
import userReducer from "./userSlice";
import chatReducer from "./chatSlice";

const store = configureStore({
  reducer: {
    supportrequest: supportrequestReducer,
    baseUrl: baseurlReducer,
    drafts: draftReducer,
    modaldraft: modalReducer,
    users: userReducer,
    chats: chatReducer,
  },
});

export default store;
